/**
 * ZenDrop template meta site IDs (`zenDropTemplates` in providers.ts) → store collection category names.
 * Other providers (AI Store Builder, AutoDS) use different template IDs and skip category creation until mapped.
 */
export const templateStoreCategoriesByTemplateId: Record<string, readonly string[]> = {
  // WomensFashion: en, it
  'ca11886c-1135-4156-b799-ca8b8b7442b9': [
    'Bags',
    'Best Sellers',
    'Leather Belts',
    'Mini Leather Goods',
    'Phone Cases',
  ],

  // WomensFashion: pt
  '3622e7f5-9de7-44e7-b993-55c0b8f7c088': [
    'Acessórios de couro',
    'Bolsas',
    'Capas de celular',
    'Cintos de couro',
    'Mais vendidos',
  ],

  // WomensFashion: fr
  '1ea95a91-721e-4057-af98-ff0db1a69afd': [
    'Accessoires',
    'Ceintures en cuir',
    'Meilleures ventes',
    'Portefeuilles en cuir',
    'Sacs',
  ],

  // WomensFashion: de
  '97b41125-114e-4d1f-9002-82116b8ec096': ['Beliebt', 'Handyhüllen', 'Ledergürtel', 'Lederwaren', 'Taschen'],

  // WomensFashion: ja
  '1cad70a0-2b88-44be-872d-a6c92fa029d1': ['スマホケース', 'バッグ', 'レザーベルト', 'レザー小物', '人気商品'],

  // WomensFashion: es
  '6e05b9b0-f6d5-451d-a2b8-987df3272a26': [
    'Artículos de piel mini',
    'Bolsas',
    'Cinturones de piel',
    'Fundas para celular',
    'Más vendidos',
  ],

  // MensFashion: en, de
  'd74e8fd5-924e-47f7-ab48-e81dc41e1761': ['Men', 'New Drops', 'Women'],

  // MensFashion: pt
  '3d57bc33-2b3b-49f2-b66e-eabf510092d9': ['Homem', 'Lançamentos', 'Mulher'],

  // MensFashion: fr
  '0d2fb94c-9082-4a0e-9829-31053bc8b76d': ['Femmes', 'Hommes', 'Nouvel arrivage'],

  // MensFashion: ja
  '1d68e4f5-09fa-465d-b626-6aaf33d66f24': ['メンズ', 'レディース', '新着アイテム'],

  // MensFashion: es
  '7848c7f6-4daf-456a-a7c9-d98638f58f21': ['Hombres', 'Mujeres', 'Novedades'],

  // MensFashion: it
  '95d436ed-f938-403d-9970-68ac2900e362': ['Donna', 'In evidenza', 'Uomo'],

  // JewelryAccessories: en, it
  '0a2ea4fb-b93a-4e1a-825d-bbf3b87d0a53': ["I'm a new collection"],

  // JewelryAccessories: pt
  '44eee06f-9d15-4b3f-9c0e-f7c3ebdf9575': ['Sou uma nova coleção'],

  // JewelryAccessories: fr
  '7221e90b-e078-4450-a9d8-5ea366d487fc': ["I'm a new collection"],

  // JewelryAccessories: de
  '6a71350b-5b86-433d-a940-9ced85ae6b6f': ['Ich bin eine neue Kollektion'],

  // JewelryAccessories: ja
  '3a878f6e-1101-4144-bec1-eb9ab3ba303e': ['新商品'],

  // JewelryAccessories: es
  '4d89dad3-bc90-4464-8119-d79840852942': ['Nueva colección'],

  // KidsBabies: en, it
  'bc5e01d3-6e5f-426f-bfc3-ca558d22572e': ['Bodysuits', 'T-shirts'],

  // KidsBabies: pt
  '56bb8b34-2426-4461-a8f8-cae47ef57120': ['Camisetas', 'Macacões'],

  // KidsBabies: fr
  'bf8ab3c7-7506-41ac-929f-7ece7bdfb878': ['Grenouillères', 'T-shirts'],

  // KidsBabies: de
  '99dd8799-c66f-4dce-8acd-77744d955a77': ['Strampler', 'T-Shirts'],

  // KidsBabies: ja
  'e410e7dd-f2dd-47d2-b3f6-c72731d32f94': ['Tシャツ', 'ボディスーツ'],

  // KidsBabies: es
  'a833716a-6dfa-4642-85fa-3b7a3d453143': ['Camisas', 'Pañaleros/ Bodies'],

  // BeautyHealth: en, it
  '049a840e-a63f-4624-8289-ac714cfeb2ec': [
    'Best Sellers',
    'Body',
    'Fragrance',
    'Hair',
    'Makeup',
    'New Arrivals',
    'Recommended',
    'Sale & Offers',
    'Sale Homepage',
    'Skincare',
    'Tools',
  ],

  // BeautyHealth: pt
  '44c2f891-5c61-4f2a-8bc3-363e0e31720a': [
    'Acessórios',
    'Cabelo',
    'Corpo',
    'Mais vendidos',
    'Maquiagem',
    'Novidades',
    'Perfume',
    'Promoção',
    'Página de promoções',
    'Recomendados',
    'Skincare',
  ],

  // BeautyHealth: fr
  '1dde53cf-acb9-4d56-b0d6-59fa98d488eb': [
    'Accessoires',
    'Cheveux',
    'Corps',
    'Maquillage',
    'Meilleurs ventes',
    'Nouveautés',
    'Parfums',
    'Promos et offres',
    "Promos page d'accueil",
    'Recommandations',
    'Visage',
  ],

  // BeautyHealth: de
  'f8754940-a182-4fd6-ab05-a3aa45c13e37': [
    'Angebote Homepage',
    'Beliebt',
    'Duft',
    'Empfohlen',
    'Haare',
    'Hautpflege',
    'Körper',
    'Make-up',
    'Neue Ware',
    'Sonderangebote',
    'Tools',
  ],

  // BeautyHealth: ja
  '2f3b761e-0d9a-4bbc-848e-5bb1a470872b': [
    'おすすめ商品',
    'スキンケア',
    'セール/ホームページ',
    'セール・特価',
    'ツール',
    'フレグランス',
    'ヘア',
    'ボディ',
    'メイクアップ',
    '人気商品',
    '新商品',
  ],

  // BeautyHealth: es
  '2d14e7c4-b9f1-4193-a657-caaeed1d0343': [
    'Accesorios',
    'Cabello',
    'Cuerpo',
    'Cuidado facial',
    'Maquillaje',
    'Más vendidos',
    'Ofertas',
    'Perfumes',
    'Página de inicio de ofertas',
    'Recién llegados',
    'Recomendado',
  ],

  // HomeGarden: en, it
  '7efa4a9a-edc1-4409-87ab-59022aa429a3': ['Bestsellers', 'Furniture', 'Lighting', 'New', 'Rugs', 'Sale'],

  // HomeGarden: pt
  '96572b0c-915e-44c7-8bfa-db9a760a9146': [
    'Iluminação',
    'Mais vendidos',
    'Móveis',
    'Novidades',
    'Promoções',
    'Tapetes',
  ],

  // HomeGarden: fr
  '27889244-a492-427e-93c4-b9aee2299735': [
    'Luminaire',
    'Meilleures ventes',
    'Mobilier',
    'Nouveautés',
    'Promo',
    'Tapis',
  ],

  // HomeGarden: de
  'aba6141d-2052-45c8-8300-e7640aea0117': ['Beleuchtung', 'Bestseller', 'Möbel', 'Neu', 'Sonderangebot', 'Teppiche'],

  // HomeGarden: ja
  'a7a6c5fa-1bb6-48d6-8188-a6d02abe16ec': ['Sale', 'ラグ', '人気商品', '家具', '新着商品', '照明'],

  // HomeGarden: es
  '4daa892f-9e6f-4eac-a454-d17b92684a44': ['Lámparas', 'Muebles', 'Más vendido', 'Nuevo', 'Oferta', 'Tapetes'],

  // SportsEntertainment: en, fr, ja, es, it
  'b701ba85-4cb1-4496-8262-207ca10d1145': [
    'Best Sellers',
    'Fitness Accessories',
    'Sale',
    'Weight Training',
    'Yoga & Pilates',
  ],

  // SportsEntertainment: pt
  '3e1ab8e6-ba78-464c-b35a-450422b13fa9': [
    'Acessórios',
    'Mais Vendidos',
    'Promoção',
    'Treino com Pesos',
    'Yoga e Pilates',
  ],

  // SportsEntertainment: de
  '1af235b3-19a0-4d30-9f59-37230fe6eefc': [
    'Beliebt',
    'Fitness-Zubehör',
    'Krafttraining',
    'Sonderangebote',
    'Yoga & Pilates',
  ],

  // BagsLuggage: en, it
  'e63c8261-1beb-4131-a5f2-b64222d95690': ['Backpacks', 'Duffle bags', 'New Arrivals', 'Travel Packs'],

  // BagsLuggage: pt
  'f4676e63-cf66-463f-81e3-8e3baa443f70': ['Lançamentos', 'Mochilas', 'Mochilas de Carga', 'Mochilas de Viagem'],

  // BagsLuggage: fr
  '8a17eff5-aba8-4e93-8315-07b6dfe85465': ['Backpacks', 'Duffle bags', 'New Arrivals', 'Travel Packs'],

  // BagsLuggage: de
  '5579def6-b9f9-47ea-92b2-81689a12897c': ['Neuheiten', 'Reiserucksäcke', 'Reisetaschen', 'Rucksäcke'],

  // BagsLuggage: ja
  '83deb44b-ea56-4aa0-9876-d6bf519ade7a': [
    'ダッフルバッグ',
    'トラベルリュック',
    'リュック・バックパック',
    '新着アイテム',
  ],

  // BagsLuggage: es
  'b157bca2-e169-40b3-af4f-5d680ac3a9b2': ['Bolsas de lona', 'Mochilas', 'Mochilas de viaje', 'Nuevos'],

  // ConsumerElectronics: en, it
  'b13ae6bf-ed09-484d-a708-707c0bd807e7': [
    'Best Sellers',
    'Computers',
    'Drones & Cameras',
    'Headphones',
    'Home Page Best Sellers',
    'Home Page Sale',
    'Mobile',
    'Sale',
    'Speakers',
    'Tablets',
    'TV & Home Cinema',
    'Wearable Tech',
  ],

  // ConsumerElectronics: pt
  'eb599f69-48f6-4e5b-af46-522ab193fb15': [
    'Alto-falantes',
    'Computadores',
    'Drones e câmeras',
    'Headphones',
    'Mais vendidos',
    'Mais vendidos da página inicial',
    'Mobile',
    'Promoções',
    'Promoções da página inicial',
    'Tablets',
    'Tecnologia vestível',
    'TV e home theater',
  ],

  // ConsumerElectronics: fr
  'aace2603-c979-4f18-9b1c-4a93273d4a57': [
    'Drones et caméras',
    'Enceintes',
    'Meilleures ventes',
    'Ordinateurs',
    'Page d’accueil meilleures ventes',
    'Page d’accueil promo',
    'Promo',
    'Tablettes',
    'Technologies portables',
    'TV et home cinéma',
    'Téléphones',
    'Écouteurs',
  ],

  // ConsumerElectronics: de
  '969d5527-fa82-455b-bfdc-2cab95c307a8': [
    'Bestseller',
    'Computer',
    'Drohnen & Kameras',
    'Handys',
    'Homepage Bestseller',
    'Homepage Sonderangebot',
    'Kopfhörer',
    'Lautsprecher',
    'Sonderangebot',
    'Tablets',
    'Tragbare Geräte',
    'TV & Heimkino',
  ],

  // ConsumerElectronics: ja
  '50fedd35-96fe-47d7-aa48-46a5a24239fe': [
    'Sale',
    'ウェアラブル',
    'スピーカー',
    'スマートフォン',
    'タブレット',
    'テレビ・ホームシアター',
    'ドローン・カメラ',
    'パソコン',
    'ヘッドホン',
    'ホームページ Sale',
    'ホームページ人気商品',
    '人気商品',
  ],

  // ConsumerElectronics: es
  'c070ce34-7e3a-425a-b413-eb0456944fd9': [
    'Audífonos',
    'Bocinas',
    'Celulares',
    'Computadoras',
    'Drones y cámaras',
    'Más vendidos',
    'Oferta',
    'Página de inicio más vendidos',
    'Página de inicio oferta',
    'T.V. y cine en casa',
    'Tabletas',
    'Tecnología portatil',
  ],

  // Pets: en, it
  '692a105f-c10d-4cc2-9bd6-3df9ca3efb5a': [
    'Bird Food',
    'Bird Houses',
    'Bird Toys',
    'Birds',
    'Cat Litters',
    'Cat Poles',
    'Cat Tools',
    'Cat Toys',
    'Cats',
    'Dog Beds',
    'Dog Collars',
    'Dog Food',
    'Dog Toys',
    'Dogs',
    'Fish & Aquatics',
    'Fish Aquariums',
    'Fish Cleaning',
    'Fish Decoration',
    "Our Pets' Choice",
    'Reptile Aquariums',
    'Reptile Decoration',
    'Reptile Heating',
    'Reptiles',
    'Small Animal Cages',
    'Small Animal Equipment',
    'Small Animal Toys',
    'Small Animals',
  ],

  // Pets: pt
  'b583ac9f-123a-4889-bac9-86e2c5004e27': [
    'Aquecedores',
    'Aquários de Peixes',
    'Brinquedos de Pássaros',
    'Brinquedos para Cães',
    'Brinquedos para Gatos',
    'Caixas para Gatos',
    'Caminhas',
    'Coleiras',
    'Comida de Pássaros',
    'Cães',
    'Decoração para Répteis',
    'Decorações para Peixes',
    'Gaiolas',
    'Gaiolas para Hamsters',
    'Gatos',
    'Itens para Gatos',
    'Itens para Pequeninos',
    'Limpeza de Aquários',
    'Mini-brinquedos',
    'Peixes e Aquáticos',
    'Pequeninos',
    'Postes Rascadores',
    'Página Inicial',
    'Pássaros',
    'Répteis',
    'Terrários',
    'Utensílios para Cães',
  ],

  // Pets: fr
  '7bdf7d82-76e4-4ccf-b02f-3ce5b5980f7c': [
    'Accessoires pour chat',
    'Accessoires pour oiseaux',
    'Accessoires pour petits animaux',
    'Aliments pour oiseaux',
    'Aquariums',
    'Arbres à chat',
    'Cabanes d’oiseaux',
    'Cages pour petits animaux',
    'Chats',
    'Chauffages pour vivarium',
    'Chiens',
    'Colliers pour chien',
    'Décoration aquarium',
    'Décoration vivarium',
    'Jouets pour chat',
    'Jouets pour chien',
    'Jouets pour petits animaux',
    'Litières pour chat',
    'Nettoyage aquarium',
    'Nourriture pour chien',
    'Oiseaux',
    'Page d’accueil',
    'Paniers pour chien',
    'Petits animaux',
    'Poissons',
    'Reptiles',
    'Vivariums pour reptiles',
  ],

  // Pets: de
  '7fceb69f-33be-43c6-90f1-bb5c80fa0339': [
    'Aquarien',
    'Aquarien für Reptilien',
    'Aquarien-Reinigung',
    'Deko für Aquarien',
    'Deko für Reptilien',
    'Fische & Zubehör',
    'Heizung für Reptilien',
    'Hunde',
    'Hundebetten',
    'Hundefutter',
    'Hundehalsbänder',
    'Hundespielzeug',
    'Katzen',
    'Katzenklo',
    'Katzenspielzeuge',
    'Katzenstangen',
    'Katzenzubehör',
    'Kleintiere',
    'Kleintierkäfige',
    'Kleintierspielzuege',
    'KleintierzubehöKleintierzubehör',
    'Reptilien',
    'Start',
    'Vogelfutter',
    'Vogelhäuschen',
    'Vogelspielzeug',
    'Vögel',
  ],

  // Pets: ja
  '5ca67c21-1175-458c-b54f-1882ca593def': [
    'ドッグフード',
    'ホームページ',
    '小動物',
    '小動物用おもちゃ',
    '小動物用アクセサリー',
    '小動物用ケージ',
    '水槽',
    '水槽クリーナー',
    '水槽用アクセサリー',
    '爬虫類用ヒーター',
    '爬虫類用品',
    '爬虫類用飼育ケース',
    '犬用おもちゃ',
    '犬用ベッド',
    '犬用品',
    '犬用首輪',
    '猫用おもちゃ',
    '猫用お手入れ用品',
    '猫用トイレ',
    '猫用品',
    '猫用爪とぎ',
    '観賞魚・アクア用品',
    '飼育ケース用アクセサリー',
    '鳥かご',
    '鳥用おもちゃ',
    '鳥用品',
    '鳥餌',
  ],

  // Pets: es
  'a80260b0-25fc-4692-bcbf-a0e9cbd1873b': [
    'Acuario de peces',
    'Acuario para reptiles',
    'Animales pequeños',
    'Arena para gatos',
    'Aves',
    'Calefacción para reptiles',
    'Camas para perro',
    'Casas para aves',
    'Collares para perro',
    'Comida para aves',
    'Comida para perro',
    'Decoración para peces',
    'Decoración para reptiles',
    'Equipo para pequeños animales',
    'Gatos',
    'Jaulas para pequeños animales',
    'Juguetes para animales pequeños',
    'Juguetes para aves',
    'Juguetes para gatos',
    'Juguetes para perro',
    'Limpieza de peces',
    'Nuestras mascotas eligen',
    'Peces y acuarios',
    'Perros',
    'Postes para gatos',
    'Reptiles',
    'Útiles para gatos',
  ],
};
